import React from 'react'
import Badge from 'react-bootstrap/Badge'
import {
  faUserSlash,
  faUserMinus,
  faUnlink,
  faRobot
} from '@fortawesome/free-solid-svg-icons'
import StatusBadge from '../../shared/badges/status-badge'

function UserBadges({ user }) {
  const terminatedOn = new Date(user.terminated_on)
  const today = new Date()
  const diffTime = today - terminatedOn
  const diffDays = Math.ceil(Math.abs(diffTime) / (1000 * 60 * 60 * 24))
  const pastTermination = today >= terminatedOn
  const terminatedTitle = pastTermination ? 'Terminated' : 'Pending Termination'

  const terminatedText = pastTermination ?
    `Employee account is active but employee was terminated ${diffDays} days ago` :
    `Employee account is active but employee will be terminated in ${diffDays} days`

  return (
    <>
      {user.business_rules_count > 0 && (
        <Badge
          pill
          className={'text-center fw-normal bg-light text-primary mx-1'}
        >
          {user.business_rules_count} Business Rule(s)
        </Badge>
      )}
      {user.status === 'inactive' ? (
        <span className="ms-2">
          <StatusBadge
            title="Disabled"
            icon={faUserSlash}
            tooltipText="Account is not active"
          />
        </span>
      ) : null}
      {user.status === 'active' && user.is_terminated ? (
        <span className="ms-2">
          <StatusBadge
            title={terminatedTitle}
            icon={faUserMinus}
            tooltipText={terminatedText}
          />
        </span>
      ) : null}
      {user.missing_payroll_record && user.status === 'active' && (
        <span className="ms-2">
          <StatusBadge
            title="Payroll"
            icon={faUnlink}
            tooltipText="No payroll record found. Add the employee ID to the user record to ensure the user is linked to a payroll record."
          />
        </span>
      )}
      {user.is_system && (
        <span className="ms-2">
          <StatusBadge
            title="System"
            icon={faRobot}
            tooltipText="User has been marked as system."
          />
        </span>
      )}
    </>
  )
}

export default UserBadges
